import React from 'react'
import styled from 'styled-components'

// Button with ripple animation
const Icon = styled.span`
    display: inline-block;
`
export default Icon
